"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getTravelerError: ()=>getTravelerError
});
const external_constants_cjs_namespaceObject = require("../constants.cjs");
function getTravelerError({ children = 0, childrenAges, lapInfants = 0, ageSelectEnabled, isInternationalFlight, isWhiteLabel, shouldAllowInternationalLapInfants, shouldValidate = false }) {
    const infantAgeCount = childrenAges ? Object.values(childrenAges).reduce((carry, age)=>carry + (0 === parseInt(age)), 0) : 0;
    const infantCount = lapInfants + infantAgeCount;
    const childrenLengthsDoNotMatch = childrenAges && Object.keys(childrenAges).length !== children;
    const hasEmptyChildrenAges = childrenAges && -1 !== Object.values(childrenAges).findIndex((value)=>'' === value);
    const hasChildrenAgeError = shouldValidate && ageSelectEnabled && children > 0 && (childrenLengthsDoNotMatch || hasEmptyChildrenAges);
    const isInternationalFlightLapInfantError = !shouldAllowInternationalLapInfants && isInternationalFlight && infantCount > 0;
    if (hasChildrenAgeError) return external_constants_cjs_namespaceObject.CHILDREN_AGE_ERROR_MESSAGE;
    if (isInternationalFlightLapInfantError) return isWhiteLabel ? external_constants_cjs_namespaceObject.WHITE_LABEL_INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE : external_constants_cjs_namespaceObject.INTERNATIONAL_LAP_INFANT_ERROR_MESSAGE;
    return null;
}
exports.getTravelerError = __webpack_exports__.getTravelerError;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getTravelerError"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
